import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

// Ampliamos los datos de proyectos para incluir múltiples imágenes y más detalles
const projects = [
  {
    id: 1,
    title: "Tendota",
    category: "Logo, Ilustraciones de personaje y Diseños personalizados",
    image: "/portfolio/tendota_1.webp",
    images: [
      "/portfolio/tendota_1.webp",
      "/portfolio/tendota_2.webp"
    ],
    description: "Desarrollo de identidad visual para Tendota, incluyendo ilustración de personajes distintivos y diseño de menú.",
    client: "Tendota",
    duration: "1 mes",
    services: ["Diseño de logo", "Ilustración de personajes", "Material promocional", "Diseño de Menú"]
  },
  {
    id: 2,
    title: "Alpha Courier",
    category: "Diseños y gestión de Redes",
    image: "/portfolio/alpha_courier.webp",
    images: [
      "/portfolio/alpha_courier.webp",
      "/portfolio/alpha_courier_2.webp",
      "/portfolio/alpha_courier_3.webp"
    ],
    description: "Estrategia de contenido y diseño para redes sociales de Alpha Courier, aumentando su visibilidad online y engagement con sus clientes.",
    client: "Alpha Courier",
    duration: "Contrato continuo",
    services: ["Gestión de redes sociales", "Diseño de contenido digital", "Estrategia de marketing", "Videos promocionales"]
  },
  {
    id: 3,
    title: "Pangolin",
    category: "Logo, Ilustraciones de personaje y Diseños personalizados",
    image: "/portfolio/pangolin.webp",
    images: [
      "/portfolio/pangolin.webp",
      "/portfolio/pangolin_2.webp",
      "/portfolio/pangolin_3.webp",
      "/portfolio/pangolin_4.webp"
    ],
    description: "Creación de marca para Pangolin con un enfoque en la originalidad y reconocimiento visual, incluyendo mascota ilustrada e identidad visual.",
    client: "Pangolin",
    duration: "Por pedido",
    services: ["Diseño de logo", "Ilustración de personaje", "Diseño de Menú"]
  },
  {
    id: 4,
    title: "Escribanía Magali Benítez",
    category: "Diseños de cartelería, merch y Página web",
    image: "/portfolio/escribania_benitez.webp",
    images: [
      "/portfolio/escribania_benitez.webp",
      "/portfolio/escribania_benitez_2.webp",
      "/portfolio/escribania_benitez_3.webp"
    ],
    description: "Desarrollo de imagen profesional y página web para la Escribanía, complementado con diseño de cartelería y merchandising corporativo.",
    client: "Escribanía Magali Benítez",
    duration: "3 meses",
    services: ["Diseño web", "Diseño para Cartelería", "Merchandising corporativo", "Identidad corporativa"]
  },
  {
    id: 5,
    title: "Diori",
    category: "Logo, Diseños y Videos personalizados",
    image: "/portfolio/diori.webp",
    images: [
      "/portfolio/diori.webp",
      "/portfolio/diori_2.webp",
      "/portfolio/diori_3.webp"
    ],
    description: "Creación de identidad visual y contenido audiovisual para Diori, mejorando su presencia digital y alcance de marca.",
    client: "Diori",
    duration: "Por pedido",
    services: ["Diseño de logo", "Contenido audiovisual", "Material promocional", "Diseño de flyers"]
  },
  {
    id: 6,
    title: "Crearte",
    category: "Logo y gestión de Redes",
    image: "/portfolio/crearte.webp",
    images: [
      "/portfolio/crearte.webp"
    ],
    description: "Diseño de logotipo y estrategia de contenido para redes sociales.",
    client: "Crearte",
    duration: "1 mes",
    services: ["Diseño de logo", "Identidad corporativa"]
  },
  {
    id: 7,
    title: "Gamepoint",
    category: "Logo, Diseños y gestión de Redes",
    image: "/portfolio/gamepoint.webp",
    images: [
      "/portfolio/gamepoint.webp",
      "/portfolio/gamepoint_2.webp",
      "/portfolio/gamepoint_3.webp"
    ],
    description: "Desarrollo de branding completo y gestión de comunidad online para Gamepoint, posicionándolo en el sector de repuesto para consolas.",
    client: "Gamepoint",
    duration: "Por pedido",
    services: ["Diseño de logo", "Identidad corporativa", "Gestión de redes sociales", "Videos promocionales"]
  },
  {
    id: 8,
    title: "Refugio Verde",
    category: "Diseño de Logos y Contenido",
    image: "/portfolio/refugio-verde.webp",
    images: [
      "/portfolio/refugio-verde.webp" 
    ],
    description: "Desarrollo de branding completo y diseño de logo y cartelería.",
    client: "Refugio Verde",
    duration: "1 mes",
    services: ["Diseño de logo", "Identidad corporativa", "Diseño de Cartelería"]
  },
];


// Extraer categorías únicas de los proyectos
const categories = [
  "Todos",
  ...Array.from(new Set(projects.map(project => project.category)))
];

// Mapeo de categorías a servicios para mostrar la relación
const categoryToService = {
  "Diseños y gestión de Redes": "Gestión de Redes Sociales",
  "Logo, Ilustraciones de personaje y Diseños personalizados": "Diseño de Logos y Contenido",
  "Diseños de cartelería, merch y Página web": "Diseño de Contenido y Páginas Web",
  "Logo, Diseños y Videos personalizados": "Diseño de Contenido",
  "Logo y gestión de Redes": "Diseño de Logos y Gestión de Redes Sociales",
  "Logo, Diseños y gestión de Redes": "Diseño de Logos y Gestión de Redes Sociales"
};

const Portfolio = () => {
  const [activeCategory, setActiveCategory] = useState("Todos");
  const [hoveredProject, setHoveredProject] = useState(null);
  const [selectedProject, setSelectedProject] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(false);

  // Detectar si es dispositivo móvil
  React.useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    // Verificar al cargar y cuando cambia el tamaño de la ventana
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, []);

  // Filtrar proyectos según la categoría seleccionada
  const filteredProjects = activeCategory === "Todos" 
    ? projects 
    : projects.filter(project => project.category === activeCategory);

  // Función para abrir el modal con el proyecto seleccionado
  const openProjectDetails = (project) => {
    setSelectedProject(project);
    setCurrentImageIndex(0);
    document.body.style.overflow = "hidden"; // Prevenir scroll en el fondo
  };

  // Función para cerrar el modal
  const closeProjectDetails = () => {
    setSelectedProject(null);
    document.body.style.overflow = "auto"; // Restaurar scroll
  };

  // Navegación de imágenes
  const goToNextImage = () => {
    if (selectedProject) {
      setCurrentImageIndex((prevIndex) => 
        prevIndex === selectedProject.images.length - 1 ? 0 : prevIndex + 1
      );
    }
  };

  const goToPrevImage = () => {
    if (selectedProject) {
      setCurrentImageIndex((prevIndex) => 
        prevIndex === 0 ? selectedProject.images.length - 1 : prevIndex - 1
      );
    }
  };

  // Manejo de gestos táctiles para deslizar imágenes
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);
  
  // Umbral mínimo para considerar un swipe
  const minSwipeDistance = 50;
  
  const onTouchStart = (e) => {
    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientX);
  };
  
  const onTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };
  
  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;
    
    if (isLeftSwipe) {
      goToNextImage();
    }
    if (isRightSwipe) {
      goToPrevImage();
    }
  };

  // Capturar clic en escape para cerrar el modal
  React.useEffect(() => {
    const handleEsc = (event) => {
      if (event.key === "Escape") closeProjectDetails();
    };
    window.addEventListener("keydown", handleEsc);
    return () => {
      window.removeEventListener("keydown", handleEsc);
      document.body.style.overflow = "auto"; // Asegurar que el scroll se restaure al desmontar
    };
  }, []);

  return (
    <motion.section
      id="portfolio"
      className="relative py-20 overflow-hidden bg-gradient-to-br from-pastelLavender to-pastelCream"
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5 }}
    >
      {/* Elementos decorativos */}
      <div className="absolute top-0 right-0 w-64 h-64 -mt-32 -mr-32 rounded-full bg-pastelYellow blur-3xl opacity-20"></div>
      <div className="absolute bottom-0 left-0 w-64 h-64 -mb-32 -ml-32 rounded-full bg-pastelLavender blur-3xl opacity-20"></div>
      
      <div className="container relative z-10 px-4 mx-auto">
        <motion.div 
          className="mb-12 text-center"
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <h2 className="mb-4 text-4xl font-bold sm:text-5xl text-primary">
            Portafolio
          </h2>
          <div className="w-24 h-1 mx-auto mb-6 rounded-full bg-primary"></div>
          <p className="max-w-2xl mx-auto text-gray-700">
            Explora algunos de nuestros proyectos más destacados y descubre cómo hemos ayudado a nuestros clientes a alcanzar sus objetivos.
          </p>
        </motion.div>
        
        {/* Filtros de categoría - Con scroll horizontal en móvil */}
        <motion.div 
          className="flex justify-start gap-3 px-1 pb-2 mb-10 overflow-x-auto flex-nowrap md:justify-center"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          {categories.map((category, index) => (
            <motion.button
              key={index}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 whitespace-nowrap flex-shrink-0 ${
                activeCategory === category
                  ? "bg-primary text-white shadow-md"
                  : "bg-white/80 text-gray-700 hover:bg-white"
              }`}
              onClick={() => setActiveCategory(category)}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.1 * index }}
            >
              {category}
            </motion.button>
          ))}
        </motion.div>
        
        {/* Grid de proyectos */}
        <motion.div 
          className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3"
          layout
        >
          <AnimatePresence mode="wait">
            {filteredProjects.length > 0 ? (
              filteredProjects.map((project, index) => (
                <motion.div
                  key={project.id}
                  className="relative overflow-hidden bg-white shadow-lg cursor-pointer rounded-xl"
                  initial={{ opacity: 0, scale: 0.9 }}
                  animate={{ opacity: 1, scale: 1 }}
                  exit={{ opacity: 0, scale: 0.9 }}
                  transition={{ duration: 0.4 }}
                  layout
                  onMouseEnter={() => setHoveredProject(project.id)}
                  onMouseLeave={() => setHoveredProject(null)}
                  whileHover={{ y: -5 }}
                  onClick={() => openProjectDetails(project)}
                >
                  <div className="relative aspect-[4/3] overflow-hidden">
                    <motion.img
                      src={project.image}
                      alt={project.title}
                      className="object-cover w-full h-full"
                      initial={{ scale: 1 }}
                      animate={{ 
                        scale: hoveredProject === project.id ? 1.1 : 1 
                      }}
                      transition={{ duration: 0.4 }}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = `https://via.placeholder.com/400x300?text=${project.title}`;
                      }}
                    />
                    
                    {/* Overlay con información */}
                    <motion.div 
                      className="absolute inset-0 flex flex-col justify-end p-6 text-white bg-gradient-to-t from-black/80 via-black/50 to-transparent"
                      initial={{ opacity: 0 }}
                      animate={{ 
                        opacity: hoveredProject === project.id ? 1 : 0 
                      }}
                      transition={{ duration: 0.3 }}
                    >
                      <motion.h3 
                        className="mb-2 text-2xl font-bold"
                        initial={{ y: 20, opacity: 0 }}
                        animate={{ 
                          y: hoveredProject === project.id ? 0 : 20,
                          opacity: hoveredProject === project.id ? 1 : 0
                        }}
                        transition={{ duration: 0.3, delay: 0.1 }}
                      >
                        {project.title}
                      </motion.h3>
                      <motion.p 
                        className="text-sm text-gray-200"
                        initial={{ y: 20, opacity: 0 }}
                        animate={{ 
                          y: hoveredProject === project.id ? 0 : 20,
                          opacity: hoveredProject === project.id ? 1 : 0
                        }}
                        transition={{ duration: 0.3, delay: 0.2 }}
                      >
                        {project.category}
                      </motion.p>
                      <motion.button
                        className="px-4 py-1 mt-3 text-sm text-white rounded-full bg-primary"
                        initial={{ y: 20, opacity: 0 }}
                        animate={{ 
                          y: hoveredProject === project.id ? 0 : 20,
                          opacity: hoveredProject === project.id ? 1 : 0
                        }}
                        transition={{ duration: 0.3, delay: 0.3 }}
                      >
                        Ver detalles
                      </motion.button>
                    </motion.div>
                  </div>
                  
                  {/* Información visible siempre (para móviles) */}
                  <div className="p-4 md:hidden">
                    <h3 className="text-xl font-bold text-primary">{project.title}</h3>
                    <p className="text-sm text-gray-600 line-clamp-1">{project.category}</p>
                    <button className="px-4 py-1 mt-2 text-sm text-white rounded-full bg-primary">
                      Ver detalles
                    </button>
                  </div>
                </motion.div>
              ))
            ) : (
              // Mensaje cuando no hay proyectos en la categoría seleccionada
              <motion.div 
                className="py-12 text-center col-span-full"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
              >
                <p className="text-lg text-gray-600">
                  Aún no tenemos proyectos en esta categoría. ¡Pronto agregaremos más!
                </p>
              </motion.div>
            )}
          </AnimatePresence>
        </motion.div>
        
        {/* CTA */}
        <motion.div 
          className="mt-12 text-center"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.3 }}
        >
          <motion.a
            href="#contact"
            className="inline-block px-8 py-3 text-white transition-all duration-300 rounded-full shadow-md bg-primary hover:shadow-lg hover:bg-darkGreen"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            ¿Tienes un proyecto en mente?
          </motion.a>
        </motion.div>
      </div>

      {/* Modal de detalles del proyecto - Optimizado para móviles */}
      <AnimatePresence>
        {selectedProject && (
          <motion.div
            className="fixed inset-0 z-50 flex items-center justify-center p-4 overflow-y-auto bg-black/70"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={closeProjectDetails}
          >
            <motion.div
              className="relative w-full max-w-4xl my-4 overflow-hidden bg-white rounded-xl md:my-8"
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.9, opacity: 0 }}
              onClick={(e) => e.stopPropagation()}
            >
              {/* Botón de cerrar */}
              <button
                onClick={closeProjectDetails}
                className="absolute z-10 flex items-center justify-center w-10 h-10 text-white transition-all duration-300 rounded-full top-4 right-4 bg-black/50 hover:bg-black/80"
              >
                ✕
              </button>
              
              <div className="flex flex-col md:flex-row">
                {/* Galería de imágenes */}
                <div className="w-full md:w-1/2">
                  <div 
                    className="relative overflow-hidden aspect-square md:aspect-auto"
                    onTouchStart={onTouchStart}
                    onTouchMove={onTouchMove}
                    onTouchEnd={onTouchEnd}
                  >
                    <AnimatePresence mode="wait">
                      <motion.img
                        key={currentImageIndex}
                        src={selectedProject.images[currentImageIndex]}
                        alt={`${selectedProject.title} - Imagen ${currentImageIndex + 1}`}
                        className="object-cover w-full h-full"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 0.3 }}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = `https://via.placeholder.com/500x500?text=${selectedProject.title}`;
                        }}
                      />
                    </AnimatePresence>
                    
                    {/* Instrucción para gestos en móvil */}
                    {isMobile && selectedProject.images.length > 1 && (
                      <div className="absolute left-0 right-0 py-1 text-xs text-center text-white bottom-12 bg-black/50">
                        Desliza para ver más imágenes
                      </div>
                    )}
                    
                    {/* Controles de navegación */}
                    {selectedProject.images.length > 1 && (
                      <>
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            goToPrevImage();
                          }}
                          className="absolute flex items-center justify-center w-10 h-10 text-white transition-all duration-300 -translate-y-1/2 rounded-full left-2 top-1/2 bg-black/50 hover:bg-black/80"
                          aria-label="Imagen anterior"
                        >
                          ←
                        </button>
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            goToNextImage();
                          }}
                          className="absolute flex items-center justify-center w-10 h-10 text-white transition-all duration-300 -translate-y-1/2 rounded-full right-2 top-1/2 bg-black/50 hover:bg-black/80"
                          aria-label="Imagen siguiente"
                        >
                          →
                        </button>
                        
                        {/* Indicadores de imágenes */}
                        <div className="absolute left-0 right-0 flex justify-center gap-2 bottom-4">
                          {selectedProject.images.map((_, idx) => (
                            <button
                              key={idx}
                              onClick={(e) => {
                                e.stopPropagation();
                                setCurrentImageIndex(idx);
                              }}
                              className={`w-3 h-3 rounded-full ${
                                currentImageIndex === idx
                                  ? "bg-primary"
                                  : "bg-white/70 hover:bg-white"
                              }`}
                              aria-label={`Ir a imagen ${idx + 1}`}
                            />
                          ))}
                        </div>
                      </>
                    )}
                  </div>
                  
                  {/* Miniaturas - Solo visibles en pantallas md y superiores */}
                  {selectedProject.images.length > 1 && (
                    <div className="hidden gap-2 p-2 overflow-x-auto md:flex">
                      {selectedProject.images.map((img, idx) => (
                        <button
                          key={idx}
                          onClick={() => setCurrentImageIndex(idx)}
                          className={`w-16 h-16 flex-shrink-0 rounded overflow-hidden ${
                            currentImageIndex === idx
                              ? "ring-2 ring-primary"
                              : ""
                          }`}
                        >
                          <img
                            src={img}
                            alt={`Miniatura ${idx + 1}`}
                            className="object-cover w-full h-full"
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = `https://via.placeholder.com/80x80?text=${idx + 1}`;
                            }}
                          />
                        </button>
                      ))}
                    </div>
                  )}
                </div>
                
                {/* Detalles del proyecto */}
                <div className="flex flex-col w-full p-4 md:w-1/2 md:p-6">
                  <h2 className="mb-2 text-2xl font-bold md:text-3xl text-primary">
                    {selectedProject.title}
                  </h2>
                  <p className="mb-4 text-sm text-gray-500">
                    {selectedProject.category}
                  </p>
                  
                  <div className="p-3 mb-4 rounded-lg bg-gray-50 md:p-4">
                    <h3 className="mb-2 text-lg font-semibold text-gray-800">
                      Descripción del proyecto
                    </h3>
                    <p className="text-sm text-gray-700 md:text-base">
                      {selectedProject.description}
                    </p>
                  </div>
                  
                  <div className="grid grid-cols-2 gap-3 mb-4 md:gap-4 md:mb-6">
                    <div>
                      <h4 className="text-xs font-semibold text-gray-500 md:text-sm">Cliente</h4>
                      <p className="text-sm text-gray-800 md:text-base">{selectedProject.client}</p>
                    </div>
                    <div>
                      <h4 className="text-xs font-semibold text-gray-500 md:text-sm">Duración</h4>
                      <p className="text-sm text-gray-800 md:text-base">{selectedProject.duration}</p>
                    </div>
                  </div>
                  
                  <div className="mb-4 md:mb-6">
                    <h4 className="mb-2 text-xs font-semibold text-gray-500 md:text-sm">Servicios</h4>
                    <div className="flex flex-wrap gap-2">
                      {selectedProject.services.map((service, idx) => (
                        <span 
                          key={idx}
                          className="px-2 py-1 text-xs rounded-full md:px-3 bg-pastelLavender/30 text-primary md:text-sm"
                        >
                          {service}
                        </span>
                      ))}
                    </div>
                  </div>
                  
                  {/* Miniaturas para móvil - Solo visibles en pantallas pequeñas */}
                  {selectedProject.images.length > 1 && (
                    <div className="flex gap-1 p-1 mb-4 overflow-x-auto md:hidden">
                      {selectedProject.images.map((img, idx) => (
                        <button
                          key={idx}
                          onClick={() => setCurrentImageIndex(idx)}
                          className={`w-14 h-14 flex-shrink-0 rounded overflow-hidden ${
                            currentImageIndex === idx
                              ? "ring-2 ring-primary"
                              : ""
                          }`}
                        >
                          <img
                            src={img}
                            alt={`Miniatura ${idx + 1}`}
                            className="object-cover w-full h-full"
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = `https://via.placeholder.com/80x80?text=${idx + 1}`;
                            }}
                          />
                        </button>
                      ))}
                    </div>
                  )}
                  
                  <div className="mt-auto">
                    <a
                      href="#contact"
                      onClick={closeProjectDetails}
                      className="inline-block w-full px-4 py-3 text-sm text-center text-white transition-all duration-300 rounded-full md:px-6 bg-primary hover:bg-darkGreen md:text-base"
                    >
                      ¿Quieres un proyecto similar?
                    </a>
                  </div>
                </div>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.section>
  );
};
export default Portfolio;